import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Badge } from '@/components/ui/badge';
import { Bot } from 'lucide-react';

export default function Agents() {
  const [agents, setAgents] = useState([]);
  useEffect(() => { api.get('/agents').then(r => setAgents(r.data || [])); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-widest text-muted-foreground">Agentic swarm</div>
        <h1 className="mt-2 font-display text-3xl tracking-tight">{agents.length} autonomous agents</h1>
        <p className="mt-2 text-sm text-muted-foreground">We lead. We reason and continually decipher. We execute.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {agents.map(a => (
          <div key={a.id} className="card-hover rounded-xl border border-border bg-card p-5">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="h-9 w-9 rounded-md bg-primary/10 flex items-center justify-center">
                  <Bot className="h-4 w-4 text-primary" />
                </div>
                <div className="font-medium">{a.name}</div>
              </div>
              <Badge variant={a.status === 'active' || a.status === 'running' ? 'default' : 'secondary'}>{a.status}</Badge>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
              <div className="rounded-md bg-secondary/50 px-2 py-1.5">
                <div className="text-muted-foreground text-[10px] uppercase tracking-wider">Tasks done</div>
                <div className="text-sm font-medium">{a.tasks_completed}</div>
              </div>
              <div className="rounded-md bg-secondary/50 px-2 py-1.5">
                <div className="text-muted-foreground text-[10px] uppercase tracking-wider">Queue</div>
                <div className="text-sm font-medium">{a.queue_depth}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
